export class NumberUtils {
    static truncateValue(value) {
        return Math.trunc(value * 100) / 100;
    }
    static roundValue(number, precision) {
        const factor = Math.pow(10, precision);
        const tempNumber = number * factor;
        const roundedTempNumber = Math.round(tempNumber);
        return roundedTempNumber / factor;
    }
    static formatCurrency(amount) {
        return "$" + amount.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
    }
}
//# sourceMappingURL=number-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fedelta-pos/data-client/utils/number-utils.js
// module id = null
// module chunks = 